// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9840) return "js/9840-fa3c9e67f007f717b0ba.chunk.js";
	if (chunkId === 8097) return "js/8097-384911b63008a60808ff.chunk.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"2476":"d9a2654e16bd7146c1e9","2893":"da8697d5ce308cc99b80","5267":"9fed2a64e0e568448047","5353":"ddac970b2490302272c6","5718":"8ff6b2d2d8e0690521de","9327":"8fa2e64088d5447ff987","9961":"e6035849c69294dbbeb4"}[chunkId] + ".js";
};